import request from '../api';

/*********************** 视频多语言 ***************************/
// 视频转换
export function dubbingVideo(data) {
  return request.post('/app/dubbing/dubbingVideo', data);
}

// 获取配音视频列表
export function dubbingVideoPage(data) {
  return request.post('/app/dubbing/dubbingVideoPage', data);
}

// 删除列表项
export function deleteDubbing(id) {
  return request.post(`/app/dubbing/deleteDubbing/${id}`);
}

/*********************** PDF 转视频 ***************************/
// 创建 pdf 转换
export function getPDFPageInfo(data) {
  return request.post('/app/ppt/createPpt', data);
}

// 获取App pdf转换详情
export function getAppPDFStatus(id) {
  return request.post(`/app/ppt/getAppPpt/${id}`);
}

// app pdf 转换状态
export const PDF_STATUS = {
  DRAFT: 1, // 1 草稿
  EXTRACTING: 2, // 2 提取中
  EXTRACTED: 3, // 3 提取完成
  GENERATING: 4, // 4 生成中
  GENERATED: 5, // 5 生成成功
  MERGING: 6, // 6 合成完成
  MERGED: 7, // 7 合成完成
  FAILED: -1, // -1 失败
};

// 获取App pdf转换分页列表
export function getAppPDFList(data) {
  return request.post('/app/ppt/getAppPptPage', data);
}

// 重新提取切图
export function retryCut(id) {
  return request.get(`/app/ppt/retryCut/${id}`);
}

// PDF 分页状态
export const PDF_PAGE_STATUS = {
  DRAFT: 1, // 1 草稿
  GENERATING: 2, // 2 生成中
  SUCCESS: 3, // 3 成功
  FAILED: -1, // -1 失败
};

// 查询pdf页码
export function getAppPDFPageList(data) {
  return request.post('/app/pptPage/getAppPptPagePage', data);
}

// pdf 生成视频
export function createPptVideo(data) {
  return request.post('/app/ppt/createVideo', data);
}

// 重试
export function retryPdfStep(id) {
  return request.get(`/app/ppt/reCreate/${id}`);
}

// 复制
export function copyPdf(id) {
  return request.get(`/app/ppt/copy/${id}`);
}

// pdf 生成视频（单页）
export function createVideoByOne(data) {
  return request.post('/app/ppt/createVideoByOne', data);
}

// 合并视频
export function mergeVideo(data) {
  return request.post('/app/ppt/mergeVideo', data);
}
